import { curry, pipe } from "ramda";

const validateTermsAccepted = ({ termsAccepted }) =>
  termsAccepted ? {} : { termsAccepted: ["validation_terms_required"] };

export const validateTerms = curry(
  (optIns, acceptedOptIns, declinedOptIns, fields) =>
    pipe(validateTermsAccepted)(fields)
);
